<template>
<div>
    <vue-headful title="Delete Catalog [Safety Data Sheets] :: MeritEHS" />

    <h4 class="py-3 mb-4">
        <ol class="breadcrumb font-weight-bold m-0">
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/safety-data-sheets`">
                    <i class="fa fa-files-o"></i> Safety Data Sheets
                </router-link>
            </li>
            <li class="breadcrumb-item font-weight-light">
                <router-link :to="`/safety-data-sheets#catalogs`">
                    Catalogs
                </router-link>
            </li>
            <li class="breadcrumb-item active">
                Delete: {{ catalog.catalog_name }}
            </li>
        </ol>
    </h4>
    <template v-if="!loading">
        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
    </template>
    <template v-else>
        <div class="card mb-2">
            <div class="card-header">
                Delete Catalog
            </div>
            <div class="card-body">
                <div class="alert alert-danger">
                    <strong>Warning:</strong> You are about to permanently delete this Catalog. This will NOT delete any files, it only disassociates jobsites' files from the catalog and deletes the catalog record.
                </div>
            </div>
        </div>

        <button class="btn btn-danger" @click="deleteCatalog" :disabled="deleting">
            <template v-if="!deleting">Delete</template>
            <template v-else>
                Deleting <i class="fa fa-spin fa-circle-o-notch"></i>
            </template>
        </button>
    </template>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            loading: false,
            deleting: false,
            catalog_id: this.$route.params.id,
            catalog: {},
            errors: {},
        }
    },

    computed: {

    },

    methods: {
        getCatalog() {
            //Get the data
            this.$http
                .get('safety-data-sheets/catalogs/edit/' + this.catalog_id)
                .then(response => {
                    //Set all the data
                    this.catalog = response.data.catalog;
                })
                .catch(response => {
                    //How to handle the error
                })
                .then(() => {
                    //Set loading
                    this.loading = true;
                });
        },

        deleteCatalog() {
            //Saving
            this.deleting = true;

            //Send it
            this.$http
                .post('safety-data-sheets/catalogs/delete/'+this.catalog.id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Catalog Deleted');

                    //Push back to list page
                    this.$router.push('/safety-data-sheets#catalogs');
                })
                .catch(error => {
                    //Check for error
                    if (error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
        },
    },

    mounted() {
        //Get the injuries
        this.getCatalog();
    }
}
</script>
